"use client";
import PageTitle from "@/components/center/PageTitle";
import { CollectListInterface } from "@/lib/type/collect.type";
import { Key, memo, useEffect, useState } from "react";
import { Button, Image, Space, Table } from "antd";
import ThemeLink from "@/components/link";
import dayjs from "dayjs";
import { TableRowSelection } from "antd/es/table/interface";
import { useCollectStore } from "@/lib/store/collect.store";
import type { DatePickerProps } from 'antd';
import { DatePicker, Form, Select, Input, Empty, Typography, Upload } from 'antd';
import { useInquiryStore } from "@/lib/store/inquiry.store";
import { useRouter } from 'next/navigation'
import React from 'react'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

type Props = {
    list: any[]
    offList:any[]
}
const { Search } = Input;




export default memo(function CollectIndex({
    list,offList
}: Props) {
    const { isquickQuote, setIsquickQuote } = useInquiryStore();

    const [inquiryDataList, setInquiryDataList] = useState<any[]>(list);
    // const [offListInquiryDataList, setOffListInquiryDataList] = useState<any[]>(offList);
    const [isOnLine, setIsOnLine] = useState(true);

    const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([]);
    const [date1,setDate1]=useState<number>();
    const [date2,setDate2]=useState<number>()



    const router = useRouter();


    const rowSelection: TableRowSelection<CollectListInterface> = {
        onChange: (selectedRowKeys: Key[], selectedRows: CollectListInterface[]) => {
            setSelectedRowKeys(selectedRowKeys);
        }
    };


    const columns = [{
        title: "报价明细",
        dataIndex: "detail",
        key: "detail",

    }, {
        title: "制单人",
        dataIndex: "created",
        key: "created",
    }, {
        title: "总金额",
        dataIndex: "totalAmount",
        key: "totalAmount",

    },
    {
        title: "是否转订单",
        dataIndex: "isTrans",
        key: "isTrans",
        render: (text: number) => {
            if (text == 1) {
                return "是";
            }
            if (text == 0) {
                return "否";
            }
            return 0

        }
    },
    {
        title: "报价状态",
        dataIndex: "status",
        key: "status",
        render: (text: number) => {
            if (text == 1) {
                return "快速报价中";
            }
            if (text == 2) {
                return "报价已完成";
            }
            if (text == 3) {
                return "报价已终止";
            }
            if (text == 4) {
                return "报价已过期";
            }
            return 0

        }
    },
    {
        title: "操作",
        key: "action",
        render: (text: string, record: CollectListInterface) => {
            return <Button type="link" size="small">删除</Button>;
        }
    }];
    const [form] = Form.useForm();
    const [form2] = Form.useForm();
    const handleBlur = () => {
        form.validateFields(['field']);
    };

    const quickQuoteDataTemp = [
        {
            id: '1',
            name: 'John Brown',
            model: 32,
            count: 'New York No. 1 Lake Park',
            attach: 32,
            note: '2021-06-0',
        },
        {
            id: '2',
            name: 'Jim Green',
            model: 42,
            count: 'London No. 1 Lake Park',
            attach: 42,
            note: '2021-06-08 ',
        },
        {
            id: '3',
            name: 'eaeae',
            model: 42,
            count: 'London No. 1 Lake Park',
            attach: 42,
            note: '2021-06-',
        },
        {
            id: '4',
            count: 'eaeae',
            note: '2021-',
        }
    ]

    useEffect(()=>{
        if(isOnLine){
            setInquiryDataList(list)
        }else{
            setInquiryDataList(offList)
        }
        form2.resetFields(['product2',"createDate","product1","isTrans","state","orderDate"]);
    },[isOnLine])

    const [quickQuoteData, setquickQuoteData] = useState(quickQuoteDataTemp);


    const handeleInputChange = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
        console.log(index);
        console.log(e.target.value);
        let tempArray = [...quickQuoteData]
        tempArray[index].name = e.target.value;
        setquickQuoteData(tempArray);
        console.log("123123");

    }
    const switchIsquickQuote = () => {
        setIsquickQuote(true);
    }

    const onFinish = (values: any) => {
        console.log('Received values of form:', values);
    };

    const getColumns = (add: any, remove: any) => {
        return [
            {
                title: '序号',
                dataIndex: 'key',
                align: 'center',

            },
            {
                title: '产品名称',
                dataIndex: 'alink',
                align: 'center',
                render(text: any, field: any) {
                    // 这里的写法是 Form.List 的方法 https://ant.design/components/form-cn/#components-form-demo-dynamic-form-items
                    return <Form.Item
                        rules={[{ required: true, message: '请输入产品名称' }]}
                        name={[field.name, 'model']}
                        fieldKey={[field.fieldKey, 'model']}
                    >
                        <Input placeholder='请输入产品名称' allowClear />
                    </Form.Item>
                }

            },
            {
                title: '产品型号',
                dataIndex: 'name',
                align: 'center',
                render(text: any, field: any) {
                    // 这里的写法是 Form.List 的方法 https://ant.design/components/form-cn/#components-form-demo-dynamic-form-items
                    return <Form.Item
                        rules={[{ required: true, message: '请输入型号' }]}
                        name={[field.name, 'model']}
                        fieldKey={[field.fieldKey, 'model']}
                    >
                        <Input placeholder='请输入型号' allowClear />
                    </Form.Item>
                }
            },
            {
                title: '数量',
                dataIndex: 'tel',
                align: 'center',
                width: 150,
                render(text: any, field: any) {
                    return <Form.Item
                        rules={[{ required: true, message: '请输入数量' }]}
                        name={[field.name, 'count']}
                        fieldKey={[field.fieldKey, 'count']}
                    >
                        <Input placeholder='请输入数量' allowClear />
                    </Form.Item>
                }
            },
            // {
            //     title: '学历',
            //     dataIndex: 'education',
            //     render(text, field) {
            //         return <Form.Item
            //             rules={[{ required: true, message: '请选择学历' }]}
            //             name={[field.name, 'education']}
            //             fieldKey={[field.fieldKey, 'education']}
            //         >
            //             <Select placeholder='请输入姓名' allowClear>
            //                 <Select.Option value='1'>专科</Select.Option>
            //                 <Select.Option value='2'>本科</Select.Option>
            //                 <Select.Option value='3'>研究生</Select.Option>
            //             </Select>
            //         </Form.Item>
            //     }
            // },
            {
                title: "上传附件",
                key: "attach",
                align: 'center',
                render: (text: string, record: CollectListInterface, index: number) => {
                    return <Button >+上传</Button>;
                }
            },
            {
                title: '备注',
                dataIndex: 'tel',
                align: 'center',
                render(text: any, field: any) {
                    return <Form.Item
                        // rules={[{ required: true, message: '请输入数量' }]}
                        name={[field.name, 'note']}
                        fieldKey={[field.fieldKey, 'note']}
                    >
                        <Input placeholder='可填写产品定制要求/加急' allowClear />
                    </Form.Item>
                }
            },
            {
                title: '操作',
                dataIndex: 'operate',
                className: 'operate',
                align: 'center',
                width: 120,
                render(text: any, field: any) {
                    return (
                        <>
                            <PlusOutlined onClick={() => add()} />
                            <MinusCircleOutlined style={{ marginLeft: 10 }} onClick={() => remove(field.name)} />
                        </>
                    )
                }
            }
        ]
    }
    const handleSearchChange = (value: any, e: any) => {
        if(isOnLine){
            if(value){
                console.log(value, e);
                const filArray = list.filter((item: any) => item.detail.toUpperCase().includes(value.toUpperCase()))
                setInquiryDataList(filArray)
                console.log(filArray);
            }else{
                setInquiryDataList(list)
            }
        }else{
            if(value){
                console.log(value, e);
                const filArray = offList.filter((item: any) => item.detail.toUpperCase().includes(value.toUpperCase()))
                setInquiryDataList(filArray)
                console.log(filArray);
            }else{
                setInquiryDataList(offList)
            }
        }
    }
    const handleSelectChange = (value: any, opt: any) => {
        if(isOnLine){
            console.log(value, opt);
            const filArray = list.filter((item: any) => item.status == value)
            console.log(filArray);
            setInquiryDataList(filArray)
        }else{
            console.log(value, opt);
            const filArray = offList.filter((item: any) => item.status == value)
            console.log(filArray);
            setInquiryDataList(filArray)
        }
       
    }
    const handleSelectChange2 = (value: any, opt: any) => {
        if(isOnLine){
            console.log(value, opt);
            const filArray = list.filter((item: any) => item.isTrans == value)
            console.log(filArray);
            setInquiryDataList(filArray)
        }else{
            console.log(value, opt);
            const filArray = offList.filter((item: any) => item.isTrans == value)
            console.log(filArray);
            setInquiryDataList(filArray)
        }
    }
    const onRangePickerChange= (date: any, dateString: any, piker: any) => {
        console.log(date, dateString, piker);
        if(piker == "piker1"){
            const start = new Date(dateString).getTime()
            // 返回事件戳
            setDate1(start)


        }
        if(piker == "piker2"){
            const end = new Date(dateString).getTime()

            setDate2(end)
            console.log("this is date2 ",end);
            
        }
         // 添加根据时间戳筛选的逻辑
        
    }
    useEffect(() => {
        if(date1 && !date2){
            console.log("date1 and date 2",date1, date2);
            
            const filArray = list.filter((item: any) => item.date >= date1)
            console.log(filArray);
            setInquiryDataList(filArray)
         }
         if(date1 && date2){
            const filArray = list.filter((item: any) => item.date >=date1 && item.date <=date2)
            console.log(filArray);
            setInquiryDataList(filArray)
         }
    }, [date1, date2])
    const empty = {
        emptyText: (
            <Empty
                image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                imageStyle={{ height: 300, marginLeft: 300, marginTop: 50 }}
                description={
                    <Typography.Text>
                        暂无报价单
                    </Typography.Text>
                }
            >
                <Button type="primary" className="w-[150px] " style={{ height: 50, fontSize: '20px' }} onClick={switchIsquickQuote} >快速报价</Button>
            </Empty>
        ),
    };

    return <>
        {/* 报价单组件 */}
        <div className={`${isquickQuote ? "hidden" : ""}`}>
            <div className="s-flex gap-x-3">
                <div onClick={() => setIsOnLine(true)}>
                    <PageTitle title={"商城报价单"} className={`${!isOnLine ? "text-gray-400 !border-0" : ""}`} />
                </div>
                <div onClick={() => setIsOnLine(false)}>
                    <PageTitle title="线下报价单" className={`${isOnLine ? "text-gray-400 !border-0" : ""}`} />
                </div>
                {/* 根据isonLine状态 切换线上报价单 线下报价单数据 */}
            </div>
            {/* <Button type="primary" danger size="small" disabled={!selectedRowKeys.length}
                onClick={() => onDelete(selectedRowKeys as string[])}>删除所选</Button> */}
            <div className="text-[#666666] border-b-qianhui border-b-[1px] mb-4">
                <Space className="mt-4 mb-2 ml-4 " size="large"><span>全部订单</span><span>|</span>
                    <span>快速报价中</span><span>|</span>
                    <span>报价已完成</span><span>|</span>
                    <span>报价已终止</span><span>|</span>
                    <span>报价已过期</span>
                    {/* 四种对list不同条件进行筛选 设个状态值去做检测被 默认为all显示全部订单 然后条件渲染样式 status==="all"? 变黄 */}
                </Space>
            </div>
            <div>
                <Form
                    className="flex gap-x-4 flex-col"
                    form={form2}
                >
                    <Space size="large">
                        <Form.Item label="制单日期：" name="createDate">
                            <DatePicker  onChange={(date, dateString)=>onRangePickerChange(date, dateString,"piker1")}/> 至 
                                <DatePicker onChange={(date, dateString)=>onRangePickerChange(date, dateString,"piker2")} />
                        </Form.Item>
                        <Form.Item label="是否转交订单：" name="isTrans"  >
                            <Select placeholder="请选择" onChange={handleSelectChange2} style={{ width: 150, border: '1px solid #d9d9d9' }}>
                                <Select.Option value='1'>是</Select.Option>
                                <Select.Option value='0'>否</Select.Option>-
                            </Select>
                        </Form.Item>
                        <Form.Item label="报价状态：" name="state">
                            <Select placeholder="请选择" onChange={handleSelectChange} style={{ width: 150, border: '1px solid #d9d9d9' }}>
                                <Select.Option value={1}>快速报价中</Select.Option>
                                <Select.Option value={2}>报价已完成</Select.Option>
                                <Select.Option value={3}>报价已终止</Select.Option>
                                <Select.Option value={4}>报价已过期</Select.Option>
                            </Select>
                        </Form.Item>
                    </Space>
                    <Space size="large">
                        <Form.Item label="下单日期：" name="orderDate"><Search enterButton style={{ width: 300 }} placeholder="如需多单查询,请用英文逗号，隔开"></Search></Form.Item>
                        <Form.Item label="产品名称：" name="product1"><Search enterButton placeholder="请输入产品名称" onSearch={handleSearchChange}></Search></Form.Item>
                        <Form.Item label="产品名称：" name="product2"><Search enterButton placeholder="请输入产品名称" onSearch={handleSearchChange} ></Search></Form.Item>
                    </Space>
                    <div>
                        <div className="bg-[#fef3f0] py-3 pl-4 mb-4 text-[#8e8b8a]">
                            报价有效期: 报价完成日期后 30 天为报价有效期，若超过此期限需重新报价
                        </div>
                    </div>
                </Form>
            </div>

            <Table dataSource={inquiryDataList} columns={columns} rowKey={"id"} pagination={false}
                rowSelection={{ ...rowSelection }} locale={empty} />

        </div>
        {/* 快速询价组件 */}
        <div className={`${!isquickQuote ? "hidden" : ""}`}>
            <div className="s-flex gap-x-3">
                <div>
                    <PageTitle title={"商城报价单"} className={`${!isOnLine ? "text-gray-400 !border-0" : ""}`} />
                </div>
                <div>
                    <PageTitle title="支持来图来样非标定制" className={`${isOnLine ? "text-gray-400 !border-0" : ""}`} />
                </div>
                {/* 根据isonLine状态 切换线上报价单 线下报价单数据 */}
                <div className="text-main ml-[750px] text-[18px] cursor-pointer w-[120px]" onClick={() => setIsquickQuote(false)}>{"返回报价单>"}</div>
            </div>
            <Form className='table-edit-form' form={form} onFinish={onFinish} initialValues={{
                // 初始化两行
                tableForm: [{}, {}]
            }} >
                <Form.List name='tableForm'>
                    {(fields, { add, remove }) => {
                        // 将Table视为 Form.List 中循环的 Form.Item
                        return (
                            <Table
                                dataSource={fields}
                                columns={getColumns(add, remove) as any}
                                rowKey='key'
                                pagination={false}
                            />
                        )
                    }}
                </Form.List>
                {/* footer */}
                <div className="flex justify-between mt-8">
                    <div>
                        <Button type="primary" className="w-[100px] mr-4 " onClick={switchIsquickQuote} > <i className="ri-folder-add-line"></i><span className="">批量导入</span></Button>
                        <span className="mr-4">{"批量导入模板下载>>"}</span>
                        <span><i className="ri-error-warning-fill text-main"></i><span className="text-[#bebebe]">小提示: 想获得100%的产品识别成功事，请按照模板格式上传清单</span></span>
                    </div>
                    <div className="pr-[80px]">
                        <Form.Item>
                            <Button htmlType='submit' type='primary'>
                                确认
                            </Button>
                        </Form.Item>
                    </div>
                </div>

            </Form>
        </div>




    </>;

});
